import React from 'react';
import { Modal, Button, Table, Tooltip, Typography, Space, Tag } from 'antd';
import { SendOutlined, MailOutlined, ShopOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ShopifySendMockupModal = ({ visible, onCancel, onConfirm, mockupReadyOrders, loading }) => {
    const columns = [
        {
            title: '#',
            key: 'index',
            width: 50,
            align: 'center',
            render: (_, record, index) => (
                <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{index + 1}</Text>
            )
        },
        {
            title: 'Order Number',
            dataIndex: 'orderNumber',
            key: 'orderNumber',
            width: 150,
            render: (text) => (
                <Space>
                    <ShopOutlined style={{ color: '#95BF47', fontSize: 12 }} />
                    <Text style={{ fontSize: 12, fontWeight: '500' }}>#{text}</Text>
                </Space>
            )
        },
        {
            title: 'Line Item ID',
            dataIndex: 'lineItemId',
            key: 'lineItemId',
            width: 140,
            render: (text) => <Text style={{ fontSize: 12, fontFamily: 'monospace' }}>{text}</Text>
        },
        {
            title: 'Product Name',
            dataIndex: 'productTitle',
            key: 'productTitle',
            ellipsis: true,
            render: (text) => (
                <Tooltip title={text}>
                    <Text style={{ fontSize: 12 }}>{text}</Text>
                </Tooltip>
            )
        },
        {
            title: 'Customer Email',
            dataIndex: 'customerEmail',
            key: 'customerEmail',
            width: 200,
            render: (text) => (
                <Space>
                    <MailOutlined style={{ fontSize: 11, color: '#1890ff' }} />
                    <Text style={{ fontSize: 12 }}>{text || 'N/A'}</Text>
                </Space>
            )
        },
        {
            title: 'Store',
            dataIndex: 'storeName',
            key: 'storeName',
            width: 150,
            render: (text) => (
                <Tag color="green" style={{ fontSize: 11 }}>
                    {text}
                </Tag>
            )
        }
    ];

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MailOutlined style={{ color: '#1890ff' }} />
                    <span>Send Mockup via Email</span>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    Cancel
                </Button>,
                <Button 
                    key="submit"
                    type="primary" 
                    icon={<SendOutlined />}
                    onClick={onConfirm}
                    loading={loading}
                >
                    Send Email
                </Button>
            ]}
            width='75%'
            styles={{
                body: {
                    padding: '24px'
                }
            }}
        >
            <div style={{ marginBottom: 16 }}>
                <Text>
                    Are you sure you want to send mockup emails for the following order items?
                </Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Mockups will be sent via email using the store's email address. 
                    Each order will be processed independently in the background.
                </Text>
            </div>
            
            <Table
                dataSource={mockupReadyOrders}
                rowKey="id"
                pagination={false}
                size="small"
                columns={columns}
                scroll={{ y: 400 }}
            />
            
            <div style={{ marginTop: 16, padding: 12, backgroundColor: '#e6f7ff', borderRadius: 6 }}>
                <Text strong style={{ color: '#1890ff' }}>
                    Selected Items: {mockupReadyOrders.length}
                </Text>
                <br />
                <Text type="secondary" style={{ fontSize: 11 }}>
                    Emails will be sent from the respective store email addresses with mockup attachments.
                </Text>
            </div>
        </Modal>
    );
};

export default ShopifySendMockupModal;
